import MainLayout from "layout/MainLayout";
import React from "react";
import { Outlet } from "react-router-dom";

const OperatorLayout = () => {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
};

export default OperatorLayout;
